import React from 'react'

export const ResourceContext = React.createContext({})